<template>
  <el-dialog
    :title="action === 'edit' ? $t('text.editDevice') : $t('text.addDevice')"
    :visible="show"
    @close="closeDialog"
    @open="init"
    :close-on-click-modal="false"
    width="600px"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item
        :label="$t('text.walletOrCardType')"
        :label-width="formLabelWidth"
        prop="processorCode"
      >
        <el-select
          v-model="form.processorCode"
          filterable
          :placeholder="$t('message.chooseOne')"
          :disabled="action === 'edit'"
        >
          <el-option
            v-for="type in typeList"
            :key="type.name"
            :label="type.name"
            :value="type.value"
          />
        </el-select>
      </el-form-item>

      <el-form-item
        :label="$t('text.walletOrCardNumber')"
        :label-width="formLabelWidth"
        prop="phoneNumber"
      >
        <el-input
          v-model="form.phoneNumber"
          autocomplete="off"
          :placeholder="$t('message.inputPhoneNumberOrCardAccount')"
          :disabled="action === 'edit'"
          @input="(val) => handleInput(val, 'phoneNumber')"
        ></el-input>
      </el-form-item>

      <el-form-item
        :label="$t('text.balance')"
        :label-width="formLabelWidth"
        prop="balance"
      >
        <el-input
          v-model="form.balance"
          autocomplete="off"
          :placeholder="$t('message.inputAccountBalance')"
          @input="(val) => handleInput(val, 'balance')"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="submit" v-if="isButton"
        >{{ $t('text.confirm') }}
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "SmsForwarderInfoEdit",
  props: {
    show: Boolean,
    value: Object,
    action: String,
    channelOption: Array
  },
  data() {
    return {
      dialogShow: this.show,
      isButton: true,
      isDisabled: false,
      typeList: [],
      form: {
        processorCode: "",
        phoneNumber: "",
        balance: ""
      },
      formLabelWidth: "120px",
      rules: {
        processorCode: [
          {
            required: true,
            message: this.$t('message.processorCodeRequiredError'),
            trigger: ["blur", "change"]
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: this.$t('message.phoneNumberRequiredError'),
            trigger: ["blur", "change"]
          },
          {
            min: 1,
            max: 20,
            message: this.$t('message.phoneNumberLengthError'),
            trigger: ["blur", "change"]
          }
        ],
        balance: [
          {
            required: true,
            message: this.$t('message.inputAccountBalance'),
            trigger: ["blur", "change"]
          }
        ]
      }
    };
  },
  methods: {
    handleInput(val, type) {
      switch (type) {
        case "balance":
          val = val.replace(/[^\d.]/g, ""); // 清除“数字”和“.”以外的字符
          val = val.replace(/\.{2,}/g, "."); // 只保留第一个. 清除多余的
          val = val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
          val = val.replace(/^(-)*(\d+)\.(\d\d).*$/, "$1$2.$3"); // 只能输入两个小数
          if (val.indexOf(".") < 0 && val !== "") {
            // 以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
            val = parseFloat(val);
          }

          break;

        case "phoneNumber":
          const regex = /[^A-Za-z0-9]+/g;
          val = val.replace(regex, "");
          break;

        default:
          break;
      }
      this.form[type] = val;
      this.$forceUpdate();
    },
    init() {
      if (this.action === "edit") {
        this.form = Object.assign({}, this.value);
        this.form.balance = this.$formatter.FenToYuan(
          null,
          null,
          this.value.balance,
          null
        );
      }
    },
    closeDialog() {
      // this.dialogShow = false;
      this.form = {
        processorCode: "",
        phoneNumber: "",
        balance: ""
      };
      this.$refs["form"].resetFields(); //关闭的时候重置表单
      this.$emit("update:show", false);
    },
    getTypeList() {
      this.axios
        .get("/smsForwarderInfo/selectStatementProviderOptions", {
          params: {}
        })
        .then((res) => {
          if (res.code === 200) {
            this.typeList = res.data;
          }
        });
    },
    submit() {
      console.log(this.form);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          if (this.action === "add") {
            this.axios
              .post("/smsForwarderInfo/smsForwarderInfoAdd", this.form)
              .then((res) => {
                if (res.code === 500) {
                  this.$notify.error({
                    title: this.$t('text.prompt'),
                    message: res.msg
                  });
                  return false;
                }

                let filename;
                var contentDisposition = res.headers["content-disposition"];
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(contentDisposition);
                if (matches != null && matches[1]) {
                  filename = matches[1].replace(/['"]/g, "");
                }
                console.log(filename);

                let blob = new Blob([res.data], {
                  type: "text/plain"
                });
                // 将blob对象转为一个URL
                var blobURL = window.URL.createObjectURL(blob);
                // 创建一个a标签
                var tempLink = document.createElement("a");
                // 隐藏a标签
                tempLink.style.display = "none";
                // 设置a标签的href属性为blob对象转化的URL
                tempLink.href = blobURL;
                // 给a标签添加下载属性
                tempLink.setAttribute("download", filename);
                if (typeof tempLink.download === "undefined") {
                  tempLink.setAttribute("target", "_blank");
                }
                // 将a标签添加到body当中
                document.body.appendChild(tempLink);
                // 启动下载
                tempLink.click();
                // 下载完毕删除a标签
                document.body.removeChild(tempLink);
                window.URL.revokeObjectURL(blobURL);

                this.$message({
                  title: this.$t('text.prompt'),
                  message: this.$t('message.addSmsForwarderInfoSuccess'),
                  type: "success"
                });

                this.$bus.$emit("refresh"); //通知刷新

                this.closeDialog();
              });
          }

          if (this.action === "edit") {
            this.$refs["form"].validate((valid) => {
              if (valid) {
                this.axios
                  .post("/smsForwarderInfo/smsForwarderInfoUpdate", this.form)
                  .then((res) => {
                    if (res.code === 200) {
                      this.$notify({
                        title: this.$t('text.prompt'),
                        message: res.msg,
                        type: "success"
                      });

                      this.$bus.$emit("refresh"); //通知刷新

                      this.closeDialog();
                    } else {
                      this.$notify.error({
                        title: this.$t('text.prompt'),
                        message: res.msg
                      });
                    }
                  });
              } else {
                return false;
              }
            });
          }
        } else {
          return false;
        }
      });
    }
  },
  mounted() {
    this.getTypeList();
  }
};
</script>

<style scoped>
.el-select {
  width: 100%;
}
</style>
